import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getAssets } from "@unisearch/helpers";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactSVG } from "react-svg";
import styles from "./address_popup.module.scss";

/**
 * 
customClasses
root
list
dot
country

 */

const loadAddress = (content) => {
  switch (content) {
    case "Australia":
      return (
        <div className={styles.address_card_wrapper}>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_pin.svg")} />
            </div>
            <div className={styles.address_title}>Address:</div>
            <div className={styles.address_text}>
              Suite 98 Level 3, 515 Kent Street, Sydney, NSW 2000
            </div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_mail.svg")} />
            </div>
            <div className={styles.address_title}> Email:</div>
            <div className={styles.address_text}>info@myunisearch.com</div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_phone.svg")} />
            </div>
            <div className={styles.address_title}>Phone:</div>
            <div className={styles.address_text}>+61 02 86280141</div>
          </div>
        </div>
      );
    case "Bangladesh":
      return (
        <div className={styles.address_card_wrapper}>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_pin.svg")} />
            </div>
            <div className={styles.address_title}>Address:</div>
            <div className={styles.address_text}>
              Unit A, Level 6, 308 Elephant Road, Dhaka, Bangladesh
            </div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_mail.svg")} />
            </div>
            <div className={styles.address_title}> Email:</div>
            <div className={styles.address_text}>info@myunisearch.com</div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_phone.svg")} />
            </div>
            <div className={styles.address_title}>Phone:</div>
            <div className={styles.address_text}>+8801673-090958</div>
          </div>
        </div>
      );
    case "India":
      return (
        <div className={`${styles.address_card_wrapper} ${styles.col_two}`}>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_pin.svg")} />
            </div>
            <div className={styles.address_title}>Bangalore Office:</div>
            <div className={styles.address_text}>
              2nd Floor, RR Image, 4th Cross, Pandurang Nagar, Bannerghatta Main
              Road, Bangalore 560076.
            </div>
            <div className={styles.address_title} style={{ marginTop: "20px" }}>
              Chandigarh Office:
            </div>
            <div className={styles.address_text}>
              3rd Floor, S.C.O 68-69, Sector 17-B, Chandigarh.
            </div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_mail.svg")} />
            </div>
            <div className={styles.address_title}> Email:</div>
            <div className={styles.address_text}>info@myunisearch.com</div>
          </div>
        </div>
      );
    case "Malaysia":
      return (
        <div className={`${styles.address_card_wrapper} ${styles.col_two}`}>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_pin.svg")} />
            </div>
            <div className={styles.address_title}>Address:</div>
            <div className={styles.address_text}>
              N - 3 - 9, Plaza Damas 2, No. 60, Jalan Sri Hartamas 1, 50480 Sri
              Hartamas, Kuala Lumpur
            </div>
          </div>
          <div className={styles.address_card}>
            <div className={styles.address_icon}>
              <ReactSVG src={getAssets("assets/icons/address_mail.svg")} />
            </div>
            <div className={styles.address_title}> Email:</div>
            <div className={styles.address_text}>info@myunisearch.com</div>
          </div>
        </div>
      );
    default:
      return <></>;
  }
};

export const AddressPopup = ({ customClasses }) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        className={`${styles.address_country_lists} ${
          customClasses?.root ? customClasses?.root : ""
        }`}
      >
        <div
          onClick={() => {
            setContent("Australia");
            handleOpen();
          }}
          className={`${styles.address_country_list} ${
            customClasses?.list ? customClasses?.list : ""
          }`}
        >
          <ReactSVG
            className={styles.address_flag}
            src={getAssets("assets/icons/flag_australia.svg")}
          />
          <span
            className={`${styles.address_country} ${
              customClasses?.country ? customClasses?.country : ""
            }`}
          >
            Australia
          </span>
        </div>
        <span
          className={`${styles.dot} ${
            customClasses?.dot ? customClasses?.dot : ""
          }`}
        ></span>

        <div
          onClick={() => {
            setContent("Bangladesh");
            handleOpen();
          }}
          className={`${styles.address_country_list} ${
            customClasses?.list ? customClasses?.list : ""
          }`}
        >
          <ReactSVG
            className={styles.address_flag}
            src={getAssets("assets/icons/flag_bangladesh.svg")}
          />
          <span
            className={`${styles.address_country} ${
              customClasses?.country ? customClasses?.country : ""
            }`}
          >
            Bangladesh
          </span>
        </div>
        <span
          className={`${styles.dot} ${
            customClasses?.dot ? customClasses?.dot : ""
          }`}
        ></span>

        {/* <div
          onClick={() => {
            setContent("India");
            handleOpen();
          }}
          className={`${styles.address_country_list} ${
            customClasses?.list ? customClasses?.list : ""
          }`}
        >
          <ReactSVG
            className={styles.address_flag}
            src={getAssets("assets/icons/flag_india.svg")}
          />

          <span
            className={`${styles.address_country} ${
              customClasses?.country ? customClasses?.country : ""
            }`}
          >
            India
          </span>
        </div>
        <span
          className={`${styles.dot} ${
            customClasses?.dot ? customClasses?.dot : ""
          }`}
        ></span> */}

        <div
          onClick={() => {
            setContent("Malaysia");
            handleOpen();
          }}
          className={`${styles.address_country_list} ${
            customClasses?.list ? customClasses?.list : ""
          }`}
        >
          <ReactSVG
            className={styles.address_flag}
            src={getAssets("assets/icons/flag_malaysia.svg")}
          />
          <span
            className={`${styles.address_country} ${
              customClasses?.country ? customClasses?.country : ""
            }`}
          >
            Malaysia
          </span>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        classes={{
          paper: styles.address_modal,
        }}
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <h4 className={styles.modal_title}>{content}</h4>
          <div className={styles.modal_content}>{loadAddress(content)}</div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddressPopup;
